import React, { useEffect, useState } from "react";
import './Room.css';
import { Grid, TextField, Box, TableBody, Checkbox, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import {
  AXIOS_TIMEOUT,
  BACKEND_BASE_URL,
  BASE_URL,
  GET_CATEOGORY_DATA,
  GET_ROOM,
  HotelRoomCateogory,
  ItemStatus,
  RateCardType,
  SET_ROOM,
  SUCCESS,
  isEmpty,
  isFeatureAllowed,
  printDebugLog,
} from "../../constants/Constants";
import axios from "axios";
import DialogBox from "../../global/DialogBox";
import SnpComponent from "../../global/SnpComponent";
import {
  Button, RadioGroup, FormControlLabel,
  FormLabel, Radio
} from "@mui/material";

import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CustomDataGrid from "../../global/CustomDataGrid";

import useAuth from "../../hooks/useAuth";
import { BANQUET_PRICE_CREATE, BANQUET_PRICE_DELETE, BANQUET_PRICE_UPDATE, BANQUETBOOKING, BANQUETCREATE, BANQUETUPDATE, ROOM_PRICE_CREATE, ROOM_PRICE_DELETE, ROOM_PRICE_UPDATE, ROOM_QR_CODE_SYSTEM, ROOMCREATE, ROOMUPDATE } from "../../constants/Permissions";

export default function CreateRoom() {
  const INITIAL_SNP_COMPONENT = {
    showDialog: false,
    outSideClickDismiss: true,
    title: "",
    subTitle: "",
    negativeAction: "",
    positiveAction: "",
    positiveReq: false,
    isLoader: false,
    iconReq: false,
    iconContent: "",
    snackBarOpen: false,
    snackBarMsg: "",
    cancelExtra: false,
    negativeReq: false,
    requestType: 0,
  };
  const INITIAL_RATECARD = {
    index: -1,
    name: "",
    sAmt: 0.0,
    status: ItemStatus.ACTIVE,
    id: "",
    hourlyAmt: 0.0,
    type: RateCardType.HOTEL_NORMAL
  }

  const INITIAL_CATGDATA = {
    id: "",
    catgName: "",
  };
  const INITIAL_ROOM_DATA = {
    id: "",
    catgId: "",
    catgName: "",
    roomNo: "",
    roomType: "",
    priceList: {},
    features: [],
    typeStr: "",
    banquet: false,
  }
  const [featuresVal, setFeaturesVal] = useState("");
  const { activeShopHash, authUser, isRoleAllowed } = useAuth();
  const [snpLoader, setSnpLoader] = useState(false);
  const [isEditProduct, setEditProduct] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [roomData, setRoomData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedRateCard, setSelectedRateCard] = useState(INITIAL_RATECARD);
  const [rateCard, setRateCard] = useState([]);
  const [selectedCategory, setSelectedcategory] = useState(INITIAL_CATGDATA);
  const [roomSingleData, setRoomSingleData] = useState(INITIAL_ROOM_DATA);
  const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
  const [filterSelection, setFilterSelection] = useState(HotelRoomCateogory.HOTEL_BOTH);

  useEffect(() => {
    getCateogoryData(HotelRoomCateogory.HOTEL_ROOM);
    getRoomData();
  }, []);

  useEffect(() => {
    printDebugLog("CreateRoom filterSelection", filterSelection);
    getRoomData();
  }, [filterSelection])

  const columns = [
    {
      field: 'roomNo', headerName: 'Room No', width: 150
    },
    {
      field: 'roomType', headerName: 'Room Name', width: 250
    },
    { field: 'catgName', headerName: 'Category', width: 250 },
    { field: 'typeStr', headerName: 'Type', width: 250 },
    {
      field: "edit",
      headerName: "Edit",
      width: 90,
      renderCell: (cellValues) => {
        return (
          <EditIcon
            onClick={(event) => {
              if (cellValues.row.banquet) {
                if (isRoleAllowed(BANQUETUPDATE)) {
                  handleCellClick(event, cellValues);
                }
              } else {
                if (isRoleAllowed(ROOMUPDATE)) {
                  handleCellClick(event, cellValues);
                }
              }
            }}
          >
          </EditIcon>
        );
      }
    }
  ]

  const getCateogoryData = async (catgFilter) => {
    if (!authUser)
      return;
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}${GET_CATEOGORY_DATA}`;
    const data = {
      payLoad: {
        apiToken: authUser.apiToken,
        shopHash: activeShopHash.id,
        type: catgFilter,
      },
    };

    try {
      const response = await axios.post(catgUrl, data);

      const fullData = response.data.payLoad?.data;
      if (Array.isArray(fullData) && fullData.length > 0) {
        setCategoryData(fullData);
      } else {
        setCategoryData([]);
      }
    } catch (error) {
      console.log("getCateogoryData Error : ", error);
      // window.location.href = "#/error";
    } finally {
      setSnpLoader(false);
    }
  };

  const getRoomData = async () => {
    if (!authUser) return;

    setSnpLoader(true);

    const catgUrl = `${BACKEND_BASE_URL}${GET_ROOM}`;
    const data = {
      payLoad: {
        apiToken: authUser.apiToken,
        shopHash: activeShopHash.id,
        type: filterSelection,
      },
    };

    try {
      const response = await axios.post(catgUrl, data);

      const fullData = response.data.payLoad?.data;
      if (Array.isArray(fullData) && fullData.length > 0) {
        setRoomData(fullData);
      } else {
        setRoomData([]);
      }
    } catch (error) {
      console.log("Error : ", error);
      // window.location.href = "#/error";
    } finally {
      setSnpLoader(false);
    }
  };

  const handleCreateRoom = async () => {
    if (rateCard.length > 0) {
      setSnpLoader(true);
      const bUrl = `${BACKEND_BASE_URL}${SET_ROOM}`;
      const filledData = {
        payLoad: {
          apiToken: authUser.apiToken,
          shopHash: activeShopHash.id,
          roomNo: roomSingleData.roomNo,
          id: roomSingleData.id,
          catgId: roomSingleData.catgId,
          priceList: rateCard,
          features: roomSingleData.features,
          roomType: roomSingleData.roomType,
          banquet: roomSingleData.banquet,
        },
      };
      //console.log("handleCreateRoom", filledData)
      handleDialogClose();
      try {
        const response = await axios.post(bUrl, filledData, {
          timeout: AXIOS_TIMEOUT,
        });

        printDebugLog("handleSubmitCatg", response);
        setSnpLoader(false);
        if (response.data.status === SUCCESS) {
          getRoomData();
        } else {
          setSnpComponent({
            ...snpComponent,
            snackBarOpen: true,
            snackBarMsg: isEmpty(response.data.errorMessage) ? "Internal Error.Contact SNP Admin" : response.data.errorMessage,
          })
        }
      } catch (error) {
        setSnpLoader(false);
        console.error("error : ", error);
        // window.location.href = "#/error";
      }
    } else {
      setSnpComponent({
        ...snpComponent,
        snackBarOpen: true,
        snackBarMsg: "Please Add Price to Proceed",
      })
    }
  };


  const deleteRateCard = async (id) => {
    try {
      setSnpLoader(true);
      const delUrl = `${BACKEND_BASE_URL}delete-rate-card?apiToken=${authUser.apiToken}&shopHash=${activeShopHash.id}&id=${id}`;
      const response = await axios.get(delUrl);
      printDebugLog("deleteRateCard", response.data);
      if (response.data.status === SUCCESS) {
        const errorMessage = response.data.errorMessage || "Rate Card Deleted Successfully";
        setSnpComponent({
          ...snpComponent,
          snackBarOpen: true,
          snackBarMsg: errorMessage,
        });
        setRateCard((prevCards) => prevCards.filter((card) => card.id !== id));
        setSelectedRateCard(INITIAL_RATECARD);
      } else {
        const errorMessage = response.data.errorMessage || "Unknown error. Try again.";
        setSnpComponent({
          ...snpComponent,
          snackBarOpen: true,
          snackBarMsg: errorMessage,
        });
      }
      setSnpLoader(false);
    } catch (err) {
      setSnpLoader(false);
      console.log("deleteRateCard" + err);
    }
  }

  const persistRateCard = async () => {
    try {
      setSnpLoader(true);
      const mUrl = `${BACKEND_BASE_URL}persist-rate-card`;
      const data = {
        payLoad: {
          apiToken: authUser.apiToken,
          shopHash: activeShopHash.id,
          id: isEmpty(selectedRateCard?.id) ? "" : selectedRateCard?.id,
          prdId: roomSingleData?.id,
          sAmt: Number(selectedRateCard?.sAmt) || 0.0,
          hourlyAmt: Number(selectedRateCard?.hourlyAmt) || 0.0,
          status: Number(selectedRateCard?.status) || ItemStatus.ACTIVE,
          type: Number(selectedRateCard?.type) || RateCardType.HOTEL_NORMAL,
          name: selectedRateCard?.name,
        },
      }
      const response = await axios.post(mUrl, data);
      printDebugLog("persistRateCard", response.data);
      if (response.data.status === SUCCESS) {
        const id = response.data.payLoad.id;
        if (!isEmpty(id)) {
          setRateCard((prevCards) => {
            const isExist = prevCards.some((card) => card.id === id);
            if (isExist) {
              return prevCards.map((card) =>
                card.id === id ? { ...card, ...selectedRateCard } : card
              );
            } else {
              return [...prevCards,
              { ...selectedRateCard, id: id }
              ];
            }
          });
          setSnpComponent({
            ...snpComponent,
            snackBarOpen: true,
            snackBarMsg: "Added successfully!",
          });
        }
        setSelectedRateCard(INITIAL_RATECARD);
      } else {
        const errorMessage = response.data.errorMessage || "Unknown error. Try again.";
        setSnpComponent({
          ...snpComponent,
          snackBarOpen: true,
          snackBarMsg: errorMessage,
        });
      }
      setSnpLoader(false);
    } catch (err) {
      setSnpLoader(false);
      console.log("persistRateCard" + err);
    }
  }

  const generateRoomQr = async () => {
    try {
      setSnpLoader(true);
      const mUrl = `${BACKEND_BASE_URL}generate-room-qr?apiToken=${authUser.apiToken}&roomHash=${roomSingleData.id}`;
      const response = await axios.get(mUrl);
      printDebugLog("generateRoomQr", response.data);
      if (response.data.status === SUCCESS) {
        const path = response.data.payLoad.path;
        if (!isEmpty(path)) {
          const url = `${BASE_URL}/files/${path}`;
          window.open(url, '_blank');
        }
      } else {
        const errorMessage = response.data.errorMessage || "Unknown error. Try again.";
        setSnpComponent({
          ...snpComponent,
          snackBarOpen: true,
          snackBarMsg: errorMessage,
        });
      }
      setSnpLoader(false);
    } catch (err) {
      setSnpLoader(false);
      console.log("generateRoomQr" + err);
    }
  }


  const handleCellClick = (e, event) => {
    //console.log("handleCellClick",event.row)
    setSelectedcategory({
      id: event.row.catgId,
      catgName: event.row.catgName
    })
    setRateCard(event.row.priceList);
    setShowDialog(true);
    setEditProduct(true);
    setRoomSingleData({
      ...roomSingleData, ...event.row,
    });
  };


  const handleDialogClose = () => {
    // console.log("handleDialogClose");
    setShowDialog(false);
    setSelectedRateCard(INITIAL_RATECARD);
    setSelectedcategory(INITIAL_CATGDATA);
    setRoomSingleData(INITIAL_ROOM_DATA);
    setRateCard([]);
    setEditProduct(false);
    getRoomData();
  };



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    //console.log("handleInputChange", name, value);
    if (name === 'name' || name === 'status' || name === 'sAmt') {
      setSelectedRateCard({
        ...selectedRateCard,
        [name]: value,
      });
    } else {
      setRoomSingleData({
        ...roomSingleData,
        [name]: value,
      });
    }
  };

  const handleSelectChange = (event, catg) => {
    //console.log("handleSelectChange",catg);
    if (catg != null) {
      setSelectedcategory({ ...selectedCategory, catgId: catg.id, catgName: catg.catgName })
      setRoomSingleData({ ...roomSingleData, catgId: catg.id, catgName: catg.catgName })
    } else {
      setSelectedcategory(INITIAL_CATGDATA);
      setRoomSingleData({ ...roomSingleData, catgId: "", catgName: "" })
    }
  };

  const handleSelectListChange = (val, index) => {
    //console.log("handleSelectListChange", val, index);
    setSelectedRateCard(prev => ({
      ...prev,
      ...val,
      index: index
    }));
  };

  const handleDeleteRateCard = () => {
    if (!isEmpty(selectedRateCard?.id)) {
      deleteRateCard(selectedRateCard?.id);
    } else {
      setRateCard((prevCards) => prevCards.filter((card) => card.index !== selectedRateCard.index));
      setSelectedRateCard(INITIAL_RATECARD);
    }
  };

  const handlePersistRateCard = () => {
    if (!isEmpty(roomSingleData?.id)) {
      persistRateCard();
    } else {
      setRateCard((prevCards) => [...prevCards, selectedRateCard]);
      setSnpComponent({
        ...snpComponent,
        snackBarOpen: true,
        snackBarMsg: "Added successfully!",
      });

      setSelectedRateCard(INITIAL_RATECARD);
    }
  };

  const handleKeyDown = (evt) => {
    if (["Enter", "Tab", ","].includes(evt.key)) {
      evt.preventDefault();

      var value = featuresVal.trim();
      //console.log("productSingleData.composition ", productSingleData.composition);
      if (value) {
        if (roomSingleData.features === undefined || roomSingleData.features.length === 0) {
          setRoomSingleData({
            ...roomSingleData, features: [value]
          })
        } else {
          const foundItem = roomSingleData.features.find((item) => item.toLowerCase() === value.toLowerCase());
          if (!foundItem) {
            setRoomSingleData({
              ...roomSingleData,
              features: [...roomSingleData.features, value],
            });
          } else {
            console.log(`Found item: ${foundItem}`);
          }
        }
        setFeaturesVal("");
      }
    }
  };

  const handleDelete = (item) => {
    setRoomSingleData({
      ...roomSingleData,
      features: roomSingleData.features.filter(i => i !== item),
    });
  };

  const renderDialogContent = () => {
    return (
      <>
        <Grid container spacing={1}>
          <Grid item md={6} sm={12} xs={12} lg={6}>
            <TextField
              required
              id="roomNo"
              variant="filled"
              size="small"
              disabled={isEditProduct}
              label="Enter Room No"
              name="roomNo"
              type="number"
              defaultValue={roomSingleData.roomNo}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item md={6} sm={12} xs={12} lg={6}>
            <TextField
              id="roomType"
              variant="filled"
              size="small"
              label="Enter Room Name"
              name="roomType"
              defaultValue={roomSingleData.roomType}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          {
            isFeatureAllowed(authUser.packages, BANQUETBOOKING) &&
            <Grid item xs={12} md={6} sm={6}>
              <FormControlLabel name="banquet" value={""} checked={roomSingleData.banquet} control={<Checkbox />}
                label={roomSingleData.banquet ? "Banquet Config(Uncheck for Room)" : "Room Config(Check for Banquet)"}
                onChange={(e) => {
                  const banquetChecked = e.target.checked;
                  if (banquetChecked) {
                    getCateogoryData(HotelRoomCateogory.HOTEL_BANKQUET);
                  } else {
                    getCateogoryData(HotelRoomCateogory.HOTEL_ROOM);
                  }
                  setRoomSingleData(prev => ({
                    ...prev,
                    banquet: banquetChecked,
                  }));
                }}
              />
            </Grid>
          }
          <Grid item md={6} sm={12} xs={12} lg={6} >
            <Autocomplete
              id="catgselect"
              variant="filled"
              size="small"
              options={categoryData}
              onChange={handleSelectChange}
              getOptionLabel={(option) => option.catgName}
              defaultValue={selectedCategory}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option) => (
                <Box
                  key={option.id}
                  component="li"
                  {...props}
                >
                  {option.catgName}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a category"
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sx={{ m: 2 }}>
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>**Add Different Prices for your Room**</p>
          </Grid>
        </Grid>

        <Grid container spacing={1}
          style={{ border: "1px solid black", padding: "30px 10px" }}>
          <Grid item xs={12}>
            <FormLabel component="legend">Select type :</FormLabel>
            <RadioGroup row aria-label="type" name="type" value={selectedRateCard.type} onChange={(e) => {
              setSelectedRateCard(prev => ({
                ...prev,
                type: Number(e.target.value),
              }));
            }} >
              <FormControlLabel value={RateCardType.HOTEL_NORMAL} control={<Radio />} label="Normal" />
              <FormControlLabel value={RateCardType.HOTEL_CORPORATE} control={<Radio />} label="Corporate" />
            </RadioGroup>
          </Grid>
          <Grid item md={6} sm={6} xs={12} lg={6}>
            <TextField
              id="name"
              label="Name(Optional)"
              variant="filled"
              size="small"
              name="name"
              value={selectedRateCard.name}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item md={6} sm={6} xs={12} lg={6}>
            <TextField
              id="sAmt"
              variant="filled"
              size="small"
              label="Price(Without GST) / day"
              name="sAmt"
              value={selectedRateCard.sAmt}
              onChange={handleInputChange}
              fullWidth
            />
          </Grid>
          <Grid item md={6} sm={6} xs={12} lg={6}>
            <TextField
              id="hourlyAmt"
              variant="filled"
              size="small"
              label="Price(Without GST) / hour"
              name="hourlyAmt"
              value={selectedRateCard.hourlyAmt}
              onChange={(e) => {
                setSelectedRateCard(prev => ({
                  ...prev,
                  hourlyAmt: e.target.value,
                }));
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <FormLabel component="legend">Select Price Status :</FormLabel>
            <RadioGroup row aria-label="status" name="status" value={selectedRateCard.status.toString()} onChange={handleInputChange} >
              <FormControlLabel value={ItemStatus.ACTIVE.toString()} control={<Radio />} label="Active" />
              <FormControlLabel value={ItemStatus.INACTIVE.toString()} control={<Radio />} label="Inactive" />
            </RadioGroup>
          </Grid>
          <Grid item xs={12}>
            <Stack direction="row" spacing={2}>
              {selectedRateCard.index === -1 && (
                <Button variant="contained" color="primary" onPointerDown={() => {
                  if (roomSingleData.banquet) {
                    if (isRoleAllowed(BANQUET_PRICE_CREATE)) {
                      handlePersistRateCard();
                    }
                  } else {
                    if (isRoleAllowed(ROOM_PRICE_CREATE)) {
                      handlePersistRateCard();
                    }
                  }
                }}>
                  Add Rate Card
                </Button>
              )}

              {selectedRateCard.index >= 0 && (
                <Button variant="contained" color="lightBlue" onPointerDown={() => {
                  if (roomSingleData.banquet) {
                    if (isRoleAllowed(BANQUET_PRICE_UPDATE)) {
                      handlePersistRateCard();
                    }
                  } else {
                    if (isRoleAllowed(ROOM_PRICE_UPDATE)) {
                      handlePersistRateCard();
                    }
                  }
                }}>
                  Update Rate Card
                </Button>
              )}

              {selectedRateCard.index >= 0 && (
                <Button variant="contained" color="bRed" onPointerDown={() => {
                  if (roomSingleData.banquet) {
                    if (isRoleAllowed(BANQUET_PRICE_DELETE)) {
                      handleDeleteRateCard();
                    }
                  } else {
                    if (isRoleAllowed(ROOM_PRICE_DELETE)) {
                      handleDeleteRateCard();
                    }
                  }
                }}>
                  Delete
                </Button>
              )}
              {selectedRateCard.index >= 0 && (
                <Button variant="contained" color="primary" onPointerDown={() => setSelectedRateCard(INITIAL_RATECARD)}>
                  Cancel
                </Button>
              )}
            </Stack>
          </Grid>
          {rateCard && rateCard?.length > 0 &&
            <Grid item xs={12}>
              <TableContainer component={Paper} style={{
                maxHeight: "400px",
                overflowY: "auto",
              }}>
                <Table aria-label="simple table" className="rate_card">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Type</TableCell>
                      <TableCell align="center">Name</TableCell>
                      <TableCell align="center">Amount</TableCell>
                      <TableCell align="center">Status</TableCell>
                      <TableCell align="center">Edit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.values(rateCard).map((val, index) => {
                      return (
                        <TableRow
                          className="rate_card--row"
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell align="center">{val.type === RateCardType.HOTEL_NORMAL ? "Normal" : "Corporate"}</TableCell>
                          <TableCell align="center">{val.name}</TableCell>
                          <TableCell align="center">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", lineHeight: "1.4" }}>
                              <span>{val.sAmt}/day</span>
                              <span style={{ fontSize: "13px", color: "#666" }}>{val.hourlyAmt}/hour</span>
                            </div>
                          </TableCell>
                          <TableCell align="center">{val.status === ItemStatus.ACTIVE ? <> &#x2713;</> : "X"}</TableCell>
                          {
                            isRoleAllowed(ROOM_PRICE_UPDATE) &&
                            <TableCell align="center"><EditIcon button onPointerDown={() => handleSelectListChange(val, index)} /></TableCell>
                          }
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          }
        </Grid>

        <Grid container spacing={1} >

          <Grid item xs={12}>
            <TextField
              id="featuresVal"
              label="Enter Features"
              name="featuresVal"
              fullWidth
              size="small"
              value={featuresVal}
              onChange={(event) => setFeaturesVal(event.target.value)}
              onKeyDown={handleKeyDown}
            />
          </Grid>
          <Grid item md={2} sm={2} xs={6} lg={2}>
            {roomSingleData.features && (roomSingleData.features.map(item => (
              <div className="tag-item" key={item}>
                {item}
                <button
                  type="button"
                  className="button"
                  onClick={() => handleDelete(item)}
                >
                  &times;
                </button>
              </div>
            )))}
          </Grid>
          {
            (isEditProduct && !roomSingleData.banquet && isFeatureAllowed(authUser.packages, ROOM_QR_CODE_SYSTEM)) &&
            <Grid item xs={6}>
              <Button variant="contained" color="primary" onPointerDown={() => generateRoomQr()}>
                Generate Room Qr code
              </Button>
            </Grid>
          }

        </Grid>
      </>
    );
  };

  const renderDialogAction = () => {
    return (
      <React.Fragment>
        <Button variant="contained" color="primary" onPointerDown={() => handleCreateRoom()}>
          {!isEditProduct ? "Add" : "Update"}
        </Button>
        <Button variant="contained" color="primary" onPointerDown={() => handleDialogClose()}>
          Dismiss
        </Button>
      </React.Fragment>
    );
  }

  const renderSnpContent = () => {
    return (
      <>
        <div>
          <Button variant="contained" color="primary" style={{ float: 'right' }} className="float-right"
            onClick={(e) => {
              if (isRoleAllowed(ROOMCREATE)
                || isRoleAllowed(BANQUETCREATE)) {
                setShowDialog(true)
              }
            }}>
            Add New Room
          </Button>
          <RadioGroup
            row
            aria-label="type"
            name="type"
            value={filterSelection}
            onChange={(e) => setFilterSelection(Number(e.target.value))}
          >
            <FormControlLabel
              value={HotelRoomCateogory.HOTEL_ROOM}
              control={<Radio />}
              label="Only Room"
            />
            <FormControlLabel
              value={HotelRoomCateogory.HOTEL_BANKQUET}
              control={<Radio />}
              label="Only Banquet"
            />
            <FormControlLabel
              value={HotelRoomCateogory.HOTEL_BOTH}
              control={<Radio />}
              label="Room/Banquet"
            />
          </RadioGroup>

          < DialogBox
            showDialog={showDialog}
            title={isEditProduct ? "Update Room" : "Create New Room"}
            onClose={handleDialogClose}
            dialogContent={renderDialogContent()}
            dialogActions={renderDialogAction()}
          />
          <CustomDataGrid
            rows={roomData}
            columns={columns}
            loading={snpLoader}
            title="Show All Room"
          />
        </div>
      </>
    );
  };



  return (
    <>
      <SnpComponent showDialog={snpComponent.showDialog}
        title={snpComponent.title}
        subTitle={snpComponent.subTitle}
        negativeAction={snpComponent.negativeAction}
        positiveReq={snpComponent.positiveReq}
        positiveAction={snpComponent.positiveAction}
        negativeReq={snpComponent.negativeReq}
        iconReq={snpComponent.iconReq}
        iconContent={snpComponent.iconContent}
        content={renderSnpContent()}
        onSnackClose={() => setSnpComponent({
          ...snpComponent,
          snackBarOpen: false,
          snackBarMsg: "",
        })}
        cancelExtra={snpComponent.cancelExtra}
        snackBarOpen={snpComponent.snackBarOpen}
        snackBarMsg={snpComponent.snackBarMsg}
        outSideClickDismiss={snpComponent.outSideClickDismiss}
      />
    </>
  );
}


